<template>
  <div class="optionPage">
    <XR-head titleText="设置" :rightShow="false" ref="headObj"></XR-head>
    <mu-paper class="demo-menu">
      <mu-menu class="option-list">
        <mu-menu-item title="基本信息" leftIcon=":fa fa-user" @click="goTo('/usercenter/person')" />
        <!--<mu-menu-item title="账户安全" leftIcon="lock"/>-->
        <!--<mu-menu-item title="实名认证" leftIcon=":fa fa-credit-card"/>-->
        <mu-menu-item title="提现账户" leftIcon=":fa fa-bank" v-if="!closeCoinWithdraw" @click="goTo('/usercenter/withdrawAccount')"/> 
        <mu-menu-item title="收货地址管理" leftIcon=":fa fa-map-marker"  @click="goTo('/usercenter/address')"/> 
        <mu-menu-item title="账户安全管理" leftIcon=":fa fa-lock2"  @click="goTo('/usercenter/safe')"/>
        <mu-divider />
        <mu-menu-item title="帮助中心" @click="goTo('/helperCenter')" leftIcon=":fa fa-question-circle"/>
      </mu-menu>
    </mu-paper>
    <mu-row gutter v-if="!isWeixin">
      <mu-col width="100" tablet="50" desktop="33" class="login-div">
        <mu-raised-button @click="loginOut" label="退出登陆" icon=":fa fa-power-off" class="demo-raised-button" primary fullWidth />
      </mu-col>
    </mu-row>
  </div>
</template>

<script>
import UserCache from '../../util/cache'
export default {
  data () {
    return {
      isWeixin:false
    }
  },
  mounted(){
    let ua = navigator.userAgent.toLowerCase()
    this.isWeixin = this.isWeixinBrowser(ua);
    this.$postBase(
      this.MOBILE_URL + "/Oauth2/WeChat/wechat.ashx"
      ).then(function(res) {
      if(!res.IsSuccess){
          //ths.$refs.XRtoast.failed(res.Msg, true)
      }else{
          wx.config({
              debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              appId: res.Data.AppId, // 必填，公众号的唯一标识
              timestamp: res.Data.TimeStamp, // 必填，生成签名的时间戳
              nonceStr: res.Data.NonceStr, // 必填，生成签名的随机串
              signature: res.Data.Sign, // 必填，签名，见附录1
              jsApiList: [] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
          });
          wx.ready(function () {
              WeixinJSBridge.call('hideOptionMenu');
          });
      }
    });
  },
  methods: {
    isWeixinBrowser(ua) {
      return (/micromessenger/.test(ua)) ? true : false;
    },
    handleChange (val) {
      this.bottomNav = val
    },
    goTo(url){
      this.$router.push(url)
    },
    loginOut(){      
      UserCache.delUser()
      this.$store.dispatch('DelUser')
      this.$router.push("/login")
    }
  }
}
</script>
<style>
.optionPage {
  width:100%;
  overflow: hidden;
}
.optionPage .login-div {
  padding: 40px 16px 0 16px;
}
.optionPage .demo-raised-button {
  height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/pages/usercenter/option.vue